import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import PageShell from "@/components/PageShell";

export default function PaymentCancelPage() {
  return (
    <PageShell chrome>
      <div className="max-w-2xl mx-auto px-6 py-16 text-center" data-testid="payment-cancel-page">
        <XCircle className="h-16 w-16 text-amber-500 mx-auto mb-4" />
        <h1 className="text-2xl font-serif mb-2">Checkout cancelled</h1>
        <p className="text-sm text-muted-foreground mb-6">Your basket is still here — you can come back any time.</p>
        <div className="flex gap-3 justify-center">
          <Link to="/basket" data-testid="cancel-back-to-basket" className="text-sm text-primary underline">Back to basket</Link>
          <Link to="/" className="text-sm text-muted-foreground underline">Continue shopping</Link>
        </div>
      </div>
    </PageShell>
  );
}
